import Vuex from 'vuex'
import Vue from 'vue'
import { storageService } from "../services/StorageService.js"
import { eventBus } from '../services/EventBus.js';



// actions
import { login } from './actions/login.js';
import { addTestSchools } from './actions/addTestSchools.js';
import { clearUserSettings } from './actions/clearUserSettings.js';
import { store_user_setting } from './actions/store_user_setting.js';
import { loadStoredData } from './actions/loadStoredData.js';
import { autoLogin } from './actions/autoLogin.js';
import { setActiveSchool } from './actions/setActiveSchool.js';
import { addSchool } from './actions/addSchool.js';
import { removeSchool } from './actions/removeSchool.js';
import { update_school } from './actions/update_school.js';
import { add_avatar } from './actions/add_avatar.js';
import { remove_avatar } from './actions/remove_avatar.js';
import { get_news } from './actions/get_news.js';
import { get_news_item } from './actions/get_news_item.js';
import { delete_news_item } from './actions/delete_news_item.js';
import { add_news_item } from './actions/add_news_item.js';
import { update_news_item } from './actions/update_news_item.js';
import { add_news_item_reaction } from './actions/add_news_item_reaction.js';
import { add_news_emoticon } from './actions/add_news_emoticon.js';
import { get_calendar } from './actions/get_calendar.js';
import { get_calendar_item } from './actions/get_calendar_item.js';
import { add_calendar_item } from './actions/add_calendar_item.js';
import { delete_calendar_item } from './actions/delete_calendar_item.js';
import { update_calendar_item } from './actions/update_calendar_item.js';
import { get_albums } from './actions/get_albums.js';
import { add_album } from './actions/add_album.js';
import { update_album } from './actions/update_album.js';
import { delete_album } from './actions/delete_album.js';
import { get_album } from './actions/get_album.js';
import { send_pushnote } from './actions/send_pushnote.js';
import { register_device } from './actions/register_device.js';
import { init_pushnotes } from './actions/init_pushnotes.js';
import { set_group } from './actions/set_group.js';
import { set_push_config } from './actions/set_push_config.js';
import { approve_news_item } from './actions/approve_news_item.js';
import { delete_news_item_reaction } from './actions/delete_news_item_reaction.js';
import { get_documents } from './actions/get_documents.js';
import { get_document_item } from './actions/get_document_item.js';
import { get_emails } from './actions/get_emails.js';
import { get_email_item } from './actions/get_email_item.js';
import { get_newsletters } from './actions/get_newsletters.js';
import { send_contact_form } from './actions/send_contact_form.js';
import { add_pdf } from './actions/add_pdf.js';
import { delete_pdf } from './actions/delete_pdf.js';
import { open_email_attachment } from './actions/open_email_attachment.js';
import { caroussel_fullscreen } from './actions/caroussel_fullscreen.js';
import { set_avatar } from './actions/set_avatar.js';
import { get_crossdomain_photo } from './actions/get_crossdomain_photo.js';
import { get_crossdomain_download } from './actions/get_crossdomain_download.js';
import { get_teacher_talks } from './actions/get_teacher_talks.js';
import { get_teacher_talks_slots } from './actions/get_teacher_talks_slots.js';
import { update_teacher_talks_slot } from './actions/update_teacher_talks_slot.js';
import { delete_teacher_talks_slot } from './actions/delete_teacher_talks_slot.js';
import { get_absences } from './actions/get_absences.js';
import { add_absence } from './actions/add_absence.js';
import { get_absence } from './actions/get_absence.js';
import { update_absence } from './actions/update_absence.js';
import { delete_absence } from './actions/delete_absence.js';
import { get_push_notes } from './actions/get_push_notes.js';
import { get_absence_reasons } from './actions/get_absence_reasons.js';
import { get_chat_persons } from './actions/get_chat_persons.js';
import { get_chat_messages } from './actions/get_chat_messages.js';
import { add_chat_message } from './actions/add_chat_message.js';
import { get_device_id } from './actions/get_device_id.js';

import { unc } from './actions/unc.js'; /* develop/ test reserved*/


// mutations
import { SET_LOGIN } from './mutations/SET_LOGIN.js';
import { ADD_TEST_SCHOOLS } from './mutations/ADD_TEST_SCHOOLS.js';
import { CLEAR_USER_SETTINGS } from './mutations/CLEAR_USER_SETTINGS.js';
import { STORE_USER_SETTING } from './mutations/STORE_USER_SETTING.js';
import { getInitialState } from './getInitialState.js';


Vue.use(Vuex);

export default new Vuex.Store({
  state: getInitialState(),
  actions:{
    login,
    addTestSchools,
    clearUserSettings,
    store_user_setting,
    loadStoredData,
    autoLogin,
    setActiveSchool,
    addSchool,
    removeSchool,
    update_school,
    add_avatar,
    remove_avatar,
    get_news,
    get_news_item,
    delete_news_item,
    add_news_item,
    update_news_item,
    add_news_item_reaction,
    add_news_emoticon,
    get_calendar,
    get_calendar_item,
    add_calendar_item,
    delete_calendar_item,
    update_calendar_item,
    get_albums,
    add_album,
    update_album,
    delete_album,
    get_album,
    send_pushnote,
    register_device, /* register for push notes */
    init_pushnotes,
    set_group,
    set_push_config,
    approve_news_item,
    delete_news_item_reaction,
    get_documents,
    get_document_item,
    get_emails,
    get_email_item,
    get_newsletters,
    send_contact_form,
    add_pdf,
    delete_pdf,
    open_email_attachment,
    caroussel_fullscreen,
    set_avatar,
    get_device_id,
    get_crossdomain_photo,
    get_crossdomain_download,
    get_teacher_talks,
    get_teacher_talks_slots,
    update_teacher_talks_slot,
    delete_teacher_talks_slot,
    get_absences,
    add_absence,
    get_absence,
    update_absence,
    delete_absence,
    get_push_notes,
    get_absence_reasons,
    get_chat_persons,
    get_chat_messages,
    add_chat_message,
    unc,
  },
  mutations: {
    SET_LOGIN,
    LOADED:(state,bool)=>{ // if api loaded data
      state.loaded=bool;
      eventBus.$emit("PULL_REFRESH_END");
    },
    ADD_TEST_SCHOOLS,
    ADD_SCHOOL:(state, school) => {
      state.user_schools.push(school);
      // save in persistent storage for later use
      var user_schools=[...state.user_schools]
      storageService.setItem('user_schools', JSON.stringify(user_schools) );
    },
    LOAD_USER_STORED:(state) => {
      // check if stored userdata is found from previous sesson
      var user_stored=storageService.getItem('user_stored');
      if(user_stored){
        user_stored=JSON.parse(user_stored);
        state.user_stored=user_stored;
      }else{
        //use the default state.user_stored
      }
    },
    LOAD_SCHOOLS:(state) => {
      // get the user settings object
      var user_schools=storageService.getItem('user_schools');

      if(user_schools){
        user_schools=JSON.parse(user_schools);
        state.user_schools=[...user_schools];
      }else{
        //use the default state
      }

    },
    CLEAR_USER_SETTINGS,
    SET_APP_SETTINGS:(state, data) => {
      state.appSettings=data;
    },
    STORE_USER_SETTING,
    SET_ACTIVE_SCHOOL:(state, school)=>{
      // deactivate current active school
      var currentActiveSchool= state.user_schools.find(school => school.active === 1)
      if(currentActiveSchool){
        currentActiveSchool.active=0;
      }

      // get passed school in list and activate
      var newActiveSchool= state.user_schools.find(s => s.username === school.username &&  s.url === school.url && s.password === school.password)
      // activate latest loggedin school
      newActiveSchool.active=1;

      let schools=[...state.user_schools];
      // save in persistent storage for later use
      storageService.setItem('user_schools', JSON.stringify(schools) );
    },
    SET_GROUPS:(state, groups) => {
      state.groups = groups;
    },
    SET_NEWS:(state, payload) => {
      
      Vue.set(state.news, payload.key, payload.news)
      
    },
    SET_NEWS_ITEM:(state, news_item)=>{
      state.news_item = news_item;
    },
    DELETE_NEWS_ITEM:(state, payload)=>{

      //alert("uypdate")
      //const copy = state.news[payload.key].slice(0);
      //copy.splice(payload.index,1); // remove element
      //console.log("XXDELETE_NEWS_ITEM "+payload.key)
      //Vue.delete( state.news[payload.key], payload.index ) 
      //state.news[payload.key].splice(payload.index, 1);
      
      Vue.delete(state.news[payload.key], payload.index);
      //Vue.set(state.news, payload.key, copy);

    },
    SET_CALENDAR:(state, payload) => {
      Vue.set(state.calendar, payload.key, payload.calendar)
    },
    SET_CALENDAR_ITEM:(state, calendar_item)=>{
      state.calendar_item = calendar_item;
    },
    DELETE_CALENDAR_ITEM:(state,payload)=>{

      state.calendar[payload.key].dates.splice(payload.index, 1);
    },
    SET_ALBUMS:(state, payload) => {

      Vue.set(state.albums, payload.store_key, payload.albums)
      
    },
    SET_ALBUM:(state, album) => {
      state.album = album;
    },
    DELETE_ALBUM:(state, payload)=>{
      
      const copy = state.albums[payload.key].slice(0);
      copy.splice(payload.index,1); // remove element

      Vue.set(state.albums, payload.key, copy);

    },
    SET_DOCUMENTS:(state, payload) => {
      Vue.set(state.documents, payload.store_key, payload.documents);
    },
    DELETE_DOCUMENT:(state, payload)=>{

      
      const copy = state.documents[payload.key].slice(0);
      copy.splice(payload.index,1); // remove element

      Vue.set(state.documents, payload.key, copy);

    },
    SET_EMAILS:(state, payload) => {
      Vue.set(state.emails, payload.store_key, payload.emails);
      
    },
    SET_NEWSLETTERS:(state, payload) => {

      Vue.set(state.newsletters, payload.store_key, payload.newsletters);
     
    },
    SET_TEACHER_TALKS:(state, payload) => {
      Vue.set(state.teacher_talks, payload.store_key, payload.talks);
    },
    SET_TEACHER_TALKS_SLOTS:(state, payload) => {
      
      Vue.set(state.teacher_talks_slots, payload.store_key, payload.slots);
    },
    SET_ABSENCES:(state, payload) => {
      // this means state.absences[key]=payload.absences
      Vue.set(state.absences, payload.store_key, payload.absences);
      
    },
    /*
    DELETE_ABSENCE:(state, payload) => {
      
      // delete absence from child.absences array
      Vue.delete(state.absences[payload.key][payload.childIndex].absences, payload.absenceIndex);
      //console.dir(state.absences[payload.key]);
      //alert("DELETE??")
      // delete whole absent child if no absences on child present
      
      //if(!state.absences[payload.key][payload.childIndex].absences.length){
       // Vue.set(state.absences, payload.store_key, payload.absences);
        //Vue.delete(state.absences[payload.key], payload.childIndex);
      //}
      //Vue.set(state.absences, payload.store_key, payload.absences);
      
    },
    */
    SET_AVATAR:(state, base64Avatar) => {
      state.appSettings.avatar = base64Avatar; // could be url too i guess
    },
    SET_GROUP:(state, payload) => {
      // sets the current grouop we are in
      state.group=payload.group;
    },
    SET_PUSH_CONFIG:(state, payload) => {
      state.appSettings.push_config={
        push_all:payload.push_all,
        push_group:payload.push_group,
      }
    },
     // eslint-disable-next-line
    RESET_STATE:(state)=>{
      
      state=getInitialState();
     
    },
    CAROUSSEL_FULLSCREEN:(state, bool)=>{
      state.caroussel_fullscreen=bool;
    },
    SET_PUSH_NOTES:(state,notes)=>{
      state.pushnotes=notes;
    },
    SET_CHAT_PERSONS:(state,payload)=>{
      state.chatpersons=payload.chatpersons;
    },
    SET_CHAT_MESSAGES:(state, payload) => {
      Vue.set(state.chat_messages, payload.store_key, payload.messages);
    },
    ADD_CHAT_MESSAGE:(state,payload) => {
    
      state.chat_messages[payload.store_key].push({origin:'me',message:payload.message, datetime: payload.datetime})
      // add "me" message to chat_messages
      
    },

  }
})